import React from 'react';
import styled from 'styled-components';
import useDynamicRecoil from '~/shared/hooks/useDynamicRecoil';
import { Flex } from '../Flex';

const Wrapper = styled(Flex)`
  margin-left: 20px;
  padding-top: 3px;
`;

const CategoryText = styled('div')`
  font-size: 16px;
  font-weight: 400;
  color: var(--text-color);
  letter-spacing: -0.03em;
  margin: 0;
`;

const Text = styled('div')`
  font-size: 16px;
  font-weight: 600;
  color: var(--text-color);
  letter-spacing: -0.03em;
  margin: 0;
`;

const Spacer = styled('div')`
  font-size: 16px;
  color: var(--text-color);
  letter-spacing: -0.03em;
  margin: 0 6px;
  padding-top: 1px;
`;

export default function BreadCrumbs() {
  const [selectedCategory] = useDynamicRecoil('selectedCategoryDisplay', undefined);
  const [selectedChart] = useDynamicRecoil('selectedChartDisplay', undefined);

  return (
    <Wrapper>
      <CategoryText>{selectedCategory}</CategoryText>
      {selectedChart && <Spacer> {`>`} </Spacer>}
      {selectedChart && <Text>{selectedChart}</Text>}
    </Wrapper>
  );
}
